/**
 * @generated SignedSource<<724e438ac64eb601e95b2552db42795a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PublishState = "ARCHIVED" | "DELETED" | "DRAFT" | "PUBLISHED" | "%future added value";
export type SearchTypeFilter = "ANNOUNCEMENT" | "EVENT" | "FILE" | "FOLDER" | "FORM" | "GENEALOGY_PERSON" | "MEMBER" | "PAGE" | "SPACE" | "%future added value";
export type searchQuery$variables = {
  query: string;
  spaceIds?: ReadonlyArray<string> | null;
  types?: ReadonlyArray<SearchTypeFilter> | null;
};
export type searchQuery$data = {
  readonly search: {
    readonly nodes: ReadonlyArray<{
      readonly node: {
        readonly publishState?: PublishState;
      };
      readonly " $fragmentSpreads": FragmentRefs<"SearchResult">;
    } | null>;
    readonly totalCount: number;
  };
};
export type searchQuery = {
  response: searchQuery$data;
  variables: searchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "types"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  },
  {
    "kind": "Variable",
    "name": "spaceIds",
    "variableName": "spaceIds"
  },
  {
    "kind": "Variable",
    "name": "types",
    "variableName": "types"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishState",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "FolderNodeInterface",
  "abstractKey": "__isFolderNodeInterface"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Color",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "light",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dark",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  (v6/*: any*/),
  (v8/*: any*/)
],
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ilSpace",
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "ownershipSpace",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "ilEvent",
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "ownershipEvent",
      "plural": false,
      "selections": (v10/*: any*/),
      "storageKey": null
    },
    {
      "alias": "ilFolders",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "FolderConnection",
      "kind": "LinkedField",
      "name": "ownershipFolders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Folder",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": (v10/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": "ownershipFolders(first:1)"
    }
  ],
  "type": "HasOwnerPermissionsInterface",
  "abstractKey": "__isHasOwnerPermissionsInterface"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mimeType",
      "storageKey": null
    }
  ],
  "type": "File",
  "abstractKey": null
},
v13 = [
  (v6/*: any*/)
],
v14 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v15 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "PendingFile",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "searchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SearchResultConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SearchResult",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SearchResult"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": (v4/*: any*/),
                    "type": "Event",
                    "abstractKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "searchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SearchResultConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SearchResult",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      {
                        "alias": "avatar",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 750
                          }
                        ],
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "image(width:750)"
                      }
                    ],
                    "type": "Member",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ],
                    "type": "Space",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v11/*: any*/),
                      (v3/*: any*/)
                    ],
                    "type": "Event",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v11/*: any*/)
                    ],
                    "type": "Folder",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v12/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v13/*: any*/),
                            "type": "Page",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v13/*: any*/),
                            "type": "Form",
                            "abstractKey": null
                          },
                          (v14/*: any*/),
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "type": "FolderItem",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v12/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Vault",
                        "kind": "LinkedField",
                        "name": "vault",
                        "plural": false,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "VaultItem",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Member",
                        "kind": "LinkedField",
                        "name": "announcer",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "publishedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "type": "Announcement",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/)
                    ],
                    "type": "Genealogy__Person",
                    "abstractKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a38cb544ac3ca33f3c37670616cf9531",
    "id": null,
    "metadata": {},
    "name": "searchQuery",
    "operationKind": "query",
    "text": "query searchQuery(\n  $query: String!\n  $spaceIds: [ID!]\n  $types: [SearchTypeFilter!]\n) {\n  search(query: $query, spaceIds: $spaceIds, types: $types) {\n    totalCount\n    nodes {\n      ...SearchResult\n      node {\n        __typename\n        ... on Event {\n          publishState\n        }\n        ... on FolderNodeInterface {\n          __isFolderNodeInterface: __typename\n          publishState\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ItemLocationInfo_item on HasOwnerPermissionsInterface {\n  __isHasOwnerPermissionsInterface: __typename\n  ilSpace: ownershipSpace {\n    id\n    name\n    color {\n      light\n      dark\n    }\n  }\n  ilEvent: ownershipEvent {\n    id\n    name\n  }\n  ilFolders: ownershipFolders(first: 1) {\n    nodes {\n      id\n      name\n    }\n  }\n}\n\nfragment SearchResult on SearchResult {\n  node {\n    id\n    __typename\n    ... on Member {\n      name\n      ...UserAvatar_member\n    }\n    ... on Space {\n      name\n      color {\n        light\n        dark\n      }\n    }\n    ... on Event {\n      name\n      ...ItemLocationInfo_item\n    }\n    ... on Folder {\n      name\n      ...ItemLocationInfo_item\n    }\n    ... on FolderItem {\n      name\n      content {\n        __typename\n        ... on File {\n          mimeType\n        }\n        ... on Page {\n          id\n        }\n        ... on Form {\n          id\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on PendingFile {\n          id\n        }\n      }\n      ...ItemLocationInfo_item\n    }\n    ... on VaultItem {\n      name\n      content {\n        __typename\n        ... on File {\n          mimeType\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on PendingFile {\n          id\n        }\n      }\n      vault {\n        id\n        name\n      }\n    }\n    ... on Announcement {\n      announcer {\n        name\n        id\n      }\n      space {\n        id\n      }\n      publishedAt\n      message\n      ...ItemLocationInfo_item\n    }\n    ... on Genealogy__Person {\n      name\n    }\n  }\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar: image(width: 750) {\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe58b78c173647690bf47d9bd0a23702";

export default node;
